import React, { Component } from 'react'
import { t } from 'i18next'
import ModalVideo from 'react-modal-video'
import ReadMoreLink from '../ReadMoreLink'
import './index.css'

export default class Construction extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeContent: 'construction',
      updating: false,
      isVideoOpen: false
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (this.state.activeContent !== nextState.activeContent) {
      this.setState({ updating: true }, () => {
        setTimeout(() => {
          this.setState({ updating: false })
        }, 500)
      })
    }
  }

  render() {
    let _content = this.props.data.content

    const content = {
      construction: {
        title: _content[0].titel,
        content: _content[0].tekst,
        list: _content[0].lijst,
        contextual: _content[0].contextueel
      },
      kvh: {
        title: _content[1].titel,
        content: _content[1].tekst,
        list: _content[1].lijst,
        contextual: _content[1].contextueel
      },
      sustainability: {
        title: _content[2].titel,
        content: _content[2].tekst,
        list: _content[2].lijst,
        contextual: _content[2].contextueel
      },
      energy: {
        title: _content[3].titel,
        content: _content[3].tekst,
        list: _content[3].lijst,
        contextual: _content[3].contextueel
      },
      preparations: {
        title: _content[4].titel,
        content: _content[4].tekst,
        list: _content[4].lijst,
        contextual: _content[4].contextueel
      },
      frames: {
        title: _content[5].titel,
        content: _content[5].tekst,
        list: _content[5].lijst,
        contextual: _content[5].contextueel
      },
      technology: {
        title: _content[6].titel,
        content: _content[6].tekst,
        list: _content[6].lijst,
        contextual: _content[6].contextueel
      }
    }

    const ReadMoreLinks = [
      {
        key: 'construction',
        text: _content[0].lees_meer_tekst
      },
      {
        key: 'kvh',
        text: _content[1].lees_meer_tekst
      },
      {
        key: 'sustainability',
        text: _content[2].lees_meer_tekst
      },
      {
        key: 'energy',
        text: _content[3].lees_meer_tekst
      },
      {
        key: 'preparations',
        text: _content[4].lees_meer_tekst
      },
      {
        key: 'frames',
        text: _content[5].lees_meer_tekst
      },
      {
        key: 'technology',
        text: _content[6].lees_meer_tekst
      }
    ]

    return (
      <div className={`Construction ${this.state.updating ? 'Construction--updating' : ''}`}>
        <article>
          <h2>{content[this.state.activeContent].title}</h2>
          {content[this.state.activeContent].content.length > 0 &&
            content[this.state.activeContent].content.map((x, i) =>
              <p key={`construction-paragraph-${i}`}>{x.paragraaf}</p>
          )}

          {content[this.state.activeContent].list &&
            <ul>
              {content[this.state.activeContent].list.map((x, i) => <li key={`const-list-key-${i}`}>{x.lijst_item}</li>)}
            </ul>
          }

          {content[this.state.activeContent].contextual &&
            content[this.state.activeContent].contextual.map((context, i) =>
              <div className="contextual" key={`context-item-${i}`}>
                <img src={context.afbeelding.sizes.large} alt={context.afbeelding.alt} />
                <div className="content">
                  <h3>{context.titel}</h3>
                  <ol className="legend">
                    {context.items.map((item, i) => <li key={`context-child-item-${i}`}>{item.item}</li>)}
                  </ol>
                </div>
              </div>
            )
          }
        </article>
        <div className="youtube" onClick={() => this.setState({ isVideoOpen: true })}>
          <i style={{
            backgroundImage: `url(${require('../../Assets/Images/Icons/youtube.svg')})`
          }} />
          <div className="link">{t('watch_videos')}</div>
        </div>
        <div
          className="image"
          style={{
            backgroundImage: `url(${require('../../Assets/Images/Construction/construction-image.jpg')})`
          }} />
        <div className="readmore-list">
          {ReadMoreLinks.map((r, i) => (
            <ReadMoreLink
              key={`ReadMoreLink-${i}`}
              inactive={this.state.activeContent === r.key}
              handler={() => this.setState({ activeContent: r.key })}>
              {r.text}
            </ReadMoreLink>
          ))}
        </div>

        <ModalVideo
          channel='youtube'
          isOpen={this.state.isVideoOpen}
          videoId='p-ua0ueB_bc'
          youtube={{
            modestbranding: true,
            showinfo: 0,
            start: 1,
            autoplay: 1
          }}
          onClose={() => this.setState({ isVideoOpen: false })} />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/Components/Construction/index.js